module.exports = __webpack_public_path__ + "static/media/insurance-02.c3997859.jpg";